import type { BrowserOptions } from '@sentry/nextjs'
import { ignoredErrors } from './constants'
import { beforeSend } from './utils'

export const sentryOptions = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NEXT_PUBLIC_APP_ENV !== 'development',
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  release: process.env.NEXT_PUBLIC_BUILD_ID,
}

export const sentryClientOptions: BrowserOptions = {
  ...sentryOptions,
  allowUrls: [
    `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${process.env.NEXT_PUBLIC_SIO_HOST_NAME}`,
    `${process.env.NEXT_PUBLIC_STATIC_ASSETS_HOST}`,
  ],
  ignoreErrors: ignoredErrors,
  beforeSend,
  // The Next.js integration rewrites frame URLs to `app:///`, which only resolves against source
  // maps uploaded to Sentry. Until the upload is set up, Sentry fetches the public source maps from
  // the CDN URLs, and `beforeSend` needs those URLs to tell our frames from third-party ones.
  integrations: integrations =>
    integrations.filter(({ name }) => name !== 'NextjsClientStackFrameNormalization'),
}
